import { Component, Input } from "@angular/core";
import { Discussion, User, VoterListConfig } from "../../../../models";

@Component({
  selector: "show-voters-button",
  templateUrl: "./show-voters-button.component.html",
  styleUrls: [
    "./show-voters-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class ShowVotersButtonComponent {
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() limit: number;
  @Input() config: VoterListConfig;
  public ownsDiscussion: boolean = false;
  public loggedInUser: any = false;

  constructor() {}

  ngOnInit() {
    this.loggedInUser = Object.keys(this.currentUser).length > 0;
    this.ownsDiscussion =
      this.currentUser.username === this.discussion.author.username;
  }
}
